import * as React from 'react';
import { css } from 'react-strict-dom';

import { Text } from '../../components';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function AuthHeading({ children }: Props) {
  return (
    <Text as="h1" style={styles.heading}>
      {children}
    </Text>
  );
}

const styles = css.create({
  heading: {
    fontWeight: 'normal',
    fontSize: 21,
    textAlign: 'center',
    // Browser default heading margin, which RSD zeroes.
    marginTop: '0.67em',
    marginBottom: 50,
  },
});
